import { LensSourceApplication } from "../../../../gql-generated/types";

const lensApplierSourceApplications = new Set<LensSourceApplication>([
    LensSourceApplication.SourceApplicationLensApplier,
    LensSourceApplication.SourceApplicationLensStudioMobile,
    LensSourceApplication.SourceApplicationLensStudioWeb,
]);

export const isLensApplierSourceApplication = (
    sourceApplication: LensSourceApplication | undefined | null,
): boolean => {
    return (
        sourceApplication !== undefined &&
        sourceApplication !== null &&
        lensApplierSourceApplications.has(sourceApplication)
    );
};
